import { createMinorSuitCore } from '../internal/core-builders';

export const MINOR_PENTACLES_CORE = createMinorSuitCore('Denari');
